import { useQuery } from '@tanstack/react-query';
import { hybridApi } from '../services/api';
import { format, subDays } from 'date-fns';

interface LaborData {
  totalLaborCost: number;
  laborCostPercentage: number;
  hoursWorked: number;
  averageWage: number;
  salesPerLaborHour: number;
}

export const useLaborCosts = (startDate?: string, endDate?: string, storeId?: string) => {
  const start = startDate || format(subDays(new Date(), 7), 'yyyy-MM-dd');
  const end = endDate || format(new Date(), 'yyyy-MM-dd');
  
  return useQuery<{ data: LaborData }, Error, LaborData>({
    queryKey: ['labor-costs', start, end, storeId],
    queryFn: async () => {
      const response = await hybridApi.getLaborCosts(start, end, storeId);
      return response;
    },
    select: (data) => data.data,
    staleTime: 300000, // 5 minutes
    refetchInterval: 600000, // 10 minutes
  });
};